module.exports = {
  BASE_URL: 'https://bblbd.com/dev/api',
  MAP_API_KEY: 'AIzaSyCuOCKe3pW4urvL-FopTEsxb-HYNp79mDs'
}
